import { gql, TypedDocumentNode } from "@apollo/client";

import {
  Maybe,
  RunScheduledForTerminationTile,
  RunsScheduledForTerminationTile,
  RunTile,
  SpaceliftMetrics,
} from "types/generated";

type GetRunsToBeTerminatedData = {
  metrics: Maybe<{
    runsScheduledForTermination: {
      totalCount: RunsScheduledForTerminationTile["totalCount"];
      runs: Array<{
        scheduledTerminationAt: RunScheduledForTerminationTile["scheduledTerminationAt"];
        runTile: Omit<RunTile, "type">;
      }>;
    };
    hasRuns: SpaceliftMetrics["hasRuns"];
  }>;
};

export const GET_RUNS_TO_BE_TERMINATED: TypedDocumentNode<GetRunsToBeTerminatedData> = gql`
  query GetRunsToBeTerminated {
    metrics {
      runsScheduledForTermination {
        totalCount
        runs {
          scheduledTerminationAt
          runTile {
            id
            title
            state
            createdAt
            needsApproval
            stackTile {
              slug
              name
            }
          }
        }
      }
      hasRuns
    }
  }
`;
